// Dependencias generales
import React from "react";
import { useEffect, useState } from 'react';
import '../../../css/common.css';
import '../../../css/initialConfigStyle.css';
import InstallerInitialConfigHeader from '../../../components/InitialConfig/InstallerInitialConfigHeader';
import StepIntro from '../../../components/InitialConfig/StepIntro'
import AsideMenu from '../../../components/InitialConfig/AsideMenu'
import Loader from '../../../components/Utils/Loader'
import WorkflowNavigationButtons from '../../../components/InitialConfig/WorkflowNavigationButtons'
import FormValidationError from "../../../components/InitialConfig/FormValidationError"
import InstallerImg from '../../../img/dark-theme/installer.png'
import ReactGA from "react-ga4";

const endpointHelias = "https://9m4y8iz04h.execute-api.eu-west-3.amazonaws.com/prod"
const updateInstallationConfiguration = endpointHelias+"/Helias/V0/Configuration/updateInstallationConfiguration"
const getInstallationConfiguration = endpointHelias+"/Helias/V0/Configuration/getInstallationConfiguration"
const putAccountIDInstallation = endpointHelias+'/Helias/V0/Configuration/putAccountIDInstallation'

//const urlJsonMunicipios = "https://www.fevergy.com/json/Municipios.json" //Producción
//const urlJsonMunicipios = "https://helias.fevergy.com/json/Municipios.json" //Prueba local 
const urlJsonMunicipios = "/json/Municipios.json" //Prueba local 

var initialConfigCommonJS = require("../../../js/initialConfigCommon.js");
var generalCommonJS = require("../../../js/generalCommon.js")

// Initial config - GeneralInfo
const GeneralInfo = () => {

  const [selectedLocation, setSelectedLocation] = useState([{ id: "", distance: "", lat: "40.4167754", long: "-3.7037902" }]) //Default Madrid

  useEffect(() => {          
    if(initialConfigCommonJS.antiBackOnboarding() === false){  
      initialConfigCommonJS.actualizarPasoWorkflowEnBBDD("GENERAL_INFO_INSTALLER")    
      cargarMunicipios()    
      document.getElementById("email").value = generalCommonJS.obtenerEmailUsuario()
      cargarConfiguracionActualPaso()        
      
      if(localStorage.getItem("installationConfigurationMode") !== null){
        document.getElementById("sectionGeneralInfo").className = "step"
        initialConfigCommonJS.visibilidadModoConfiguracion()
      }
      else{
        document.title = "HELIAS Instalador - Configuración inicial: Información general"
        generalCommonJS.registrarEventoAnalitica(ReactGA, 'REGISTRO', 'REGISTRO - GENERAL INFO', "", "")
      }    
    }

  }, []);

  function cargarConfiguracionActualPaso(){

    var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
    var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")    
    var ongoingInstallationConfigurationID = localStorage.getItem("ongoingInstallationConfiguration")    
  
    //Petición de datos para el paso actual
    var jsonPeticion = {
      "accountID": localStorage.getItem("accountID"),
      "installationID": ongoingInstallationConfigurationID,
      "GeneralInfo": "",
      "Meteo": "",
      "FV": "",
      "Battery": "",
      "Generator": "",
      "Cars": "",
      "Messaging": ""
    }
  
    // Guardo la información  
    var xhttp = new XMLHttpRequest();  
      xhttp.open("POST", getInstallationConfiguration, true);        
      xhttp.setRequestHeader('Content-Type', "application/json");
      xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
      var data = JSON.stringify(jsonPeticion);
      xhttp.onreadystatechange = function() {
        if (this.readyState === 4 && this.status === 200) {
          var jsonRespuesta = JSON.parse(this.responseText)
  
          if(jsonRespuesta.statusCode === "403"){                   
            initialConfigCommonJS.mostrarMensajeInformativo("No tiene permisos para realizar la operación.","negative")
          }
          else{          
            //Si recibo datos ya configurados lo cargo  

            if(typeof jsonRespuesta.body.GeneralInfo !== 'undefined'){
              
              if (jsonRespuesta.body.GeneralInfo.toString().length > 0){

                var configuracionPasoActual = jsonRespuesta.body.GeneralInfo

                document.getElementById("nombreInstalacion").value = configuracionPasoActual.InstallationName      
                document.getElementById("selectTipoInstalacion").value = configuracionPasoActual.InstallationType      
                document.getElementById('inputDatalistMunicipios').value = configuracionPasoActual.InstallationLocationName
                document.getElementById("idMunicipioActual").value = configuracionPasoActual.InstallationLocationName                            
                document.getElementById("direccionEmpresa").value = configuracionPasoActual.InstallationAddress
                document.getElementById("personaContacto").value = configuracionPasoActual.InstallationContact                
                document.getElementById("email").value = generalCommonJS.obtenerEmailUsuario()
                document.getElementById("telefonoContacto").value = configuracionPasoActual.InstallationPhoneNumber

              }               

            }  

            //Si no hay datos configurados entonces no hago nada  
            console.log("Configuración existente en BBDD cargada correctamente")
          }
        }
  
        if (this.readyState === 4 && this.status !== 200) {      
          initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)          
        }
      }
      xhttp.send(data);      
  }
  
  function cargarMunicipios(){
  
    var xhttp = new XMLHttpRequest();
    xhttp.open("GET", urlJsonMunicipios, true);    
    xhttp.onreadystatechange = function() {
        if (this.readyState === 4 && this.status === 200) {
          var jsonRespuestaMunicipios = JSON.parse(this.responseText)
          console.log("JSON de Municipios cargado correctamente")        
          var jsonMunicipios = JSON.parse(jsonRespuestaMunicipios.body.replaceAll("'", '"'))
  
          //AHORA CARGAR LA COMBO CON EL CONTENIDO DEL JSON        
          var listadoMunicipiosCombo = ""	
  
          if(jsonMunicipios.length > 0){
            for (var i = 0; i < jsonMunicipios.length; i++) {
                listadoMunicipiosCombo += "<option value=\""+jsonMunicipios[i].nombreMunicipio+"\" locationInfo=\""+jsonMunicipios[i].idMunicipio+"|"+jsonMunicipios[i].latitud+"|"+jsonMunicipios[i].longitud+"\"/>";											
            }  
          }                
          else{
            listadoMunicipiosCombo = "<option value=\"\">No hay municipios disponibles</option>";														
            initialConfigCommonJS.mostrarMensajeInformativo("Se ha producido un error en la carga de los municipios.","negative"); 
          }
  
          document.getElementById("datalistListadoMunicipios").innerHTML = listadoMunicipiosCombo;	
  
          if(document.getElementById("idMunicipioActual").value !== ""){        
            document.getElementById('inputDatalistMunicipios').value = document.getElementById("idMunicipioActual").value
          }
  
          console.log("Municipios cargados correctamente")
  
        }
        if (this.readyState === 4 && this.status !== 200) {                
          initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)       
        }            
    };
    xhttp.send();  
  
  }	
  
  function obtenerInformacionMunicipio(){
  
    var informacionMunicipio = ""
  
    for (var i=0;i<document.getElementById('datalistListadoMunicipios').options.length;i++) {
      if (document.getElementById('datalistListadoMunicipios').options[i].value === document.getElementById('inputDatalistMunicipios').value) {
          // obtains the data-company attrbute
          informacionMunicipio = document.getElementById('datalistListadoMunicipios').options[i].getAttribute("locationInfo")       
          break;
      }
    }
  
    return informacionMunicipio
  
  }
  
  function validacionCamposCorrecta(){

    var numeroErroresValidacion = 0

    document.getElementById("nombreInstalacion").className = ""          
    document.getElementById("inputDatalistMunicipios").className = ""          
    document.getElementById("direccionEmpresa").className = ""      
    document.getElementById("personaContacto").className = ""      
    document.getElementById("email").className = "" 
    document.getElementById("telefonoContacto").className = ""      

    if(document.getElementById("nombreInstalacion").value === ""){
      numeroErroresValidacion++
      document.getElementById("nombreInstalacion").className = "error"
    }

    if( (document.getElementById("inputDatalistMunicipios").value === "") || (obtenerInformacionMunicipio().length === 0) ){
      
      if(document.getElementById("inputDatalistMunicipios").value === ""){
        initialConfigCommonJS.mostrarMensajeInformativo("El nombre del municipio no puede estar vacío.","negative")
      }
      else{
        initialConfigCommonJS.mostrarMensajeInformativo("Debes seleccionar un municipio de la lista, comprueba que no hayas escrito espacios en blanco al principio ni al final.","negative")
      }

      numeroErroresValidacion++
      document.getElementById("inputDatalistMunicipios").className = "error"
    }

    if(document.getElementById("direccionEmpresa").value === ""){
      numeroErroresValidacion++
      document.getElementById("direccionEmpresa").className = "error"
    }

    if(document.getElementById("personaContacto").value === ""){
      numeroErroresValidacion++
      document.getElementById("personaContacto").className = "error"
    }
  
    if ( (!document.getElementById("email").value.includes("@")) || (!document.getElementById("email").value.includes(".")) ) {
      numeroErroresValidacion++
      document.getElementById("email").className = "error"
    }

    if(document.getElementById("telefonoContacto").value === ""){
      numeroErroresValidacion++
      document.getElementById("telefonoContacto").className = "error"
    }

    if(numeroErroresValidacion > 0){      
      document.getElementById("divErrorValidacionFormulario").className="message error left"
      return false
    }
    else{
      document.getElementById("divErrorValidacionFormulario").className="message error left hidden"
      return true
    }

  }

  function actualizarNombreInstalacionEnSelector(nuevoNombre){
    
    var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
  
    if (lastAuthUser !== null){  
  
      var instalacionesDisponibles = localStorage.getItem("availableInstallations").split("|")      
      var instalacion = ""
      var idInstalacionActual = localStorage.getItem("installationId")
      var instalacionPremodificacion = ""
      var instalacionPostmodificacion = ""

      //Primero actualizo la combo
      
      for (var i = 0; i < instalacionesDisponibles.length; i++) {
        instalacion = instalacionesDisponibles[i].split("·")

        // Instalación: [0]iDInstalación·[1]NombreInstalacion·[2]EstadoInstalacion

        if(idInstalacionActual === instalacion[0]){          
          instalacionPremodificacion = instalacion[0] + "·" + instalacion[1] + "·" + instalacion[2]
          instalacionPostmodificacion = instalacion[0] + "·" + nuevoNombre + "·" + instalacion[2]
          instalacion[1] = nuevoNombre
        }


        document.getElementById("radio"+i).innerHTML = nuevoNombre

      }      

      //Y por último actualizo la variable del local storage
      localStorage.setItem("availableInstallations", localStorage.getItem("availableInstallations").replaceAll(instalacionPremodificacion, instalacionPostmodificacion))
      
    }
    else{
      initialConfigCommonJS.gestionarRespuestaPeticionErronea("401")
    }

  }

  function guardarInformacionPaso(direccion){
    
    var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
    var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")    
    var ongoingInstallationConfigurationID = localStorage.getItem("ongoingInstallationConfiguration")  
    
    document.getElementById("loaderGeneralInfo").className="loader overlay"

    var datosMunicipio = obtenerInformacionMunicipio().split("|")  
    var nombreMunicipio = document.getElementById('inputDatalistMunicipios').value  
  
    var jsonGeneralInfo = {      
      "InstallationName": document.getElementById("nombreInstalacion").value,
      "InstallationLocationName": nombreMunicipio,
      "InstallationLocationId": datosMunicipio[0],
      "InstallationLocationLatitude": datosMunicipio[1],
      "InstallationLocationLongitude": datosMunicipio[2],    
      "InstallationType": document.getElementById("selectTipoInstalacion").value,            
      "InstallationAddress": document.getElementById("direccionEmpresa").value,            
      "InstallationContact": document.getElementById("personaContacto").value,            
      "InstallationEmail": document.getElementById("email").value,            
      "InstallationPhoneNumber": document.getElementById("telefonoContacto").value
    }
  
    var jsonGuardado = {
      "accountID": localStorage.getItem("accountID"),
      "installationID": ongoingInstallationConfigurationID,
      "GeneralInfo": jsonGeneralInfo
    }
  
    // Guardo la información  
    var xhttp = new XMLHttpRequest();  
    xhttp.open("POST", updateInstallationConfiguration, true);        
    xhttp.setRequestHeader('Content-Type', "application/json");
    xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
    var data = JSON.stringify(jsonGuardado)
    xhttp.onreadystatechange = function() {
        
      if (this.readyState === 4 && this.status === 200) {
        var jsonRespuestaGuardado = JSON.parse(this.responseText)
        if(jsonRespuestaGuardado.statusCode === "403"){                   
          initialConfigCommonJS.mostrarMensajeInformativo("No tiene permisos para realizar la operación.","negative")
        }
        else{          
          
          var nombreInstalacion = ""

          //Actualizo el nombre de la instalación en BBDD sólo si estoy en modo de configuración
          if(localStorage.getItem("installationConfigurationMode") !== null){

            var xhttp2 = new XMLHttpRequest();
            xhttp2.open("PUT", putAccountIDInstallation, true);        
            xhttp2.setRequestHeader('Content-Type', "application/json");
            xhttp2.setRequestHeader('Authorization', lastAuthUserIdToken);
                
            var idInstalacion = localStorage.getItem("ongoingInstallationConfiguration")
  
            var pasoWorkflow 
            if(localStorage.getItem("installationConfigurationMode") === null){
              pasoWorkflow = localStorage.getItem("ongoingStepConfiguration")
            }
            else{
              var instalacionesDisponibles = localStorage.getItem("availableInstallations").split("|")
              for (var i = 0; i < instalacionesDisponibles.length; i++) {
                if(instalacionesDisponibles[i].includes(idInstalacion)){
                  var datosInstalacion = instalacionesDisponibles[i].split("·")
                  pasoWorkflow = datosInstalacion[2]
                }
              }
            }
  
            var elementosInstalacion
            if(localStorage.getItem('customizedWorkflow') !== null){ elementosInstalacion = localStorage.getItem('customizedWorkflow') }
            else{ elementosInstalacion = "" }
  
            nombreInstalacion = document.getElementById("selectTipoInstalacion").value + "*" + document.getElementById("nombreInstalacion").value
                      
            var data2 = JSON.stringify({"IdToken": lastAuthUserIdToken, "idInstalacion": idInstalacion, "estadoConfiguracionInicial": pasoWorkflow, "elementosInstalacion": elementosInstalacion, "nombreInstalacion": nombreInstalacion});        
            
            xhttp2.onreadystatechange = function() {
  
              if (this.readyState === 4 && this.status === 200) {        
                //Si la respuesta es correcta      
                console.log("Nombre de instalación actualizado correctamente.")
  
                localStorage.setItem("installationName", nombreInstalacion)
  
                //En caso de estar en modo configuración tras primera configuración actualizo el selector de instalación con el nuevo nombre
                if(localStorage.getItem("installationConfigurationMode") !== null){
                  actualizarNombreInstalacionEnSelector(nombreInstalacion)
                }    
  
                //Por último borro las variables innecesarias del local storage
                localStorage.removeItem("deviceToConfigure")
  
                console.log("Información guardada correctamente")
  
                // Y continuo a la siguiente página    
                if(localStorage.getItem("installationConfigurationMode") === null){
                  if(localStorage.getItem("ongoingStepConfiguration") === "GENERAL_INFO_INSTALLER"){      
                    localStorage.setItem("ongoingInstallationName", document.getElementById("nombreInstalacion").value)              
                    initialConfigCommonJS.navegarDinamico(direccion)
                  }
                  else{
                    initialConfigCommonJS.mostrarMensajeInformativo('Todavía no he cargado la información para continuar, me has pillado despistao, inténtalo de nuevo ahora a ver...',"")
                  }
                }
                else{
                  initialConfigCommonJS.mostrarMensajeInformativo("Configuración guardada correctamente.","positive")
                  document.getElementById("asideDetalleConfiguracion").className += " hidden"
                  document.getElementById("loaderGeneralInfo").className="loader hidden"
                }
  
              }                        
              if (this.readyState === 4 && this.status !== 200) {                        
                module.exports.gestionarRespuestaPeticionErronea(this.status)                   
              }            
            };
            xhttp2.send(data2); 

          }
          else{ //Si estoy en modo onboarding seteo el valor en localstorage y dejo que lo guarde en BBDD "actualizarPasoWorkflowEnBBDD"
            
            nombreInstalacion = document.getElementById("selectTipoInstalacion").value + "*" + document.getElementById("nombreInstalacion").value
            
            console.log("Información guardada correctamente")
  
            // Y continuo a la siguiente página                
            if(localStorage.getItem("ongoingStepConfiguration") === "GENERAL_INFO_INSTALLER"){      
              localStorage.setItem("ongoingInstallationName", nombreInstalacion)      
              localStorage.setItem("installationName", nombreInstalacion)        
              initialConfigCommonJS.navegarDinamico(direccion)
            }
            else{
              initialConfigCommonJS.mostrarMensajeInformativo('Todavía no he cargado la información para continuar, me has pillado despistao, inténtalo de nuevo ahora a ver...',"")
            }            

          }
          
          
        }

      }
  
      if (this.readyState === 4 && this.status !== 200) {
        initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)       
      }
    }
    xhttp.send(data);      
  
  }

  function navegar(direccion){    
    if(initialConfigCommonJS.existeSesion()){
      if(direccion === "continuar"){
        if(validacionCamposCorrecta()){
          if(document.getElementById("contenedorPrincipalOpcion") !== null){
            document.getElementById("contenedorPrincipalOpcion").scrollTop = 0
          }
          guardarInformacionPaso(direccion)
        }
      }
      else{
        if(localStorage.getItem("ongoingStepConfiguration") === "GENERAL_INFO_INSTALLER"){      
          initialConfigCommonJS.navegarDinamico(direccion)
        }
        else{
          initialConfigCommonJS.mostrarMensajeInformativo('Todavía no he cargado la información para continuar, me has pillado despistao, inténtalo de nuevo ahora a ver...',"")
        }
      } 
    }
  }

  return (          
    <main id="divMainContenedorStep">
    
      <InstallerInitialConfigHeader step={"GENERAL_INFO"}/>

      <section id="sectionGeneralInfo" className="step wrapper">
        <div id="divContenedorStep" className="content-wrapper half">            
          
          <StepIntro 
            Title="Información general de empresa instaladora" 
            Intro={<><p>Ahora que ya nos conocemos, necesito que me empieces ayudando facilitándome algunos datos tuyos.</p></>} 
          />

          <form onSubmit={e => { e.preventDefault(); }} autoComplete="off">
            <fieldset>

              <fieldset className="text">
                <label htmlFor="name">Nombre de la empresa instaladora</label>
                <input type="text" id="nombreInstalacion"/>
              </fieldset>

              <fieldset className="datalist dropdown">
                <label htmlFor="municipio">Municipio</label>
                <div className="icon-wrapper">
                  <input id="inputDatalistMunicipios" list="datalistListadoMunicipios" type="text" placeholder="Selecciónalo en esta lista"/>
                </div>
                <datalist id="datalistListadoMunicipios">
                  <option value="Cargando...">Cargando</option>
                </datalist>
                <input type="text" id="idMunicipioActual" style = {{display: 'none'}}/> 
              </fieldset>

              <fieldset className="dropdown hidden">                
                <div className="icon-wrapper">
                  <select id="selectTipoInstalacion">
                    <option value="INSTALADOR" defaultChecked>INSTALADOR</option>                      
                  </select>
                </div>
              </fieldset>  

              <fieldset>
                <label className="has-tooltip" htmlFor="labelDireccionEmpresa">
                  <span className="label tooltip-label">Dirección de la empresa</span>                  
                </label>

                <fieldset className="icon-wrapper data" >                  
                  <textarea id="direccionEmpresa" name="w3review" rows="3" cols="50"></textarea>
                </fieldset>
              </fieldset>

            </fieldset>
            
            <fieldset className="text">
              <label htmlFor="name">Persona de contacto ( Nombre y apellidos )</label>
              <input type="text" id="personaContacto"/>
            </fieldset>

            <fieldset className="text hidden">
              <label htmlFor="name">E-Mail</label>
              <input type="text" id="email" disabled/>
            </fieldset>

            <fieldset className="text">
              <label htmlFor="name">Teléfono de contacto</label>
              <input type="number" id="telefonoContacto"></input>
            </fieldset>
            
          </form>

          <FormValidationError/>

          <WorkflowNavigationButtons step={"GENERAL_INFO"} navegar={navegar}/>

        </div>

      <Loader Id="loaderGeneralInfo" Mensaje=""/>


      { localStorage.getItem("installationConfigurationMode") === null
          ? <picture className="main-illustration installer">
              <picture className="layer">
                <img src={InstallerImg} alt="installer"/>
              </picture>
            </picture>
          : <></>
      }        

      </section>
      
      <AsideMenu selectedLocation={selectedLocation} setSelectedLocation={setSelectedLocation}/>

    </main>
    
  )
}

export default GeneralInfo